import { formatHashtag } from "./campaignPayload";

const HASHTAG_DEFAULT = "bg-slate-100 text-slate-600";
const HASHTAG_SELECTED = "bg-violet-200/95 text-violet-800";

export function formatHashtagsString(tags = []) {
    return tags.map(formatHashtag).filter(Boolean).join(" ");
}

export function getHashtagTone(selected = false) {
    return selected ? HASHTAG_SELECTED : HASHTAG_DEFAULT;
}

export function getRelevanceTone(score) {
    if (score == null) return "bg-slate-100 text-slate-600";
    if (score >= 80) return "bg-emerald-50 text-emerald-700";
    if (score >= 60) return "bg-amber-50 text-amber-700";
    return "bg-slate-100 text-slate-600";
}

export function getRelevanceTextColor(score) {
    if (score == null) return "text-slate-600";
    if (score >= 80) return "text-emerald-700";
    if (score >= 60) return "text-amber-700";
    return "text-slate-600";
}

export function getCardSurfaceClass(score, isSelected) {
    if (isSelected) {
        return "border-violet-200 bg-gradient-to-br from-violet-50/70 to-white ring-1 ring-violet-200/50";
    }
    if (score != null && score >= 80) {
        return "border-emerald-100/80 bg-gradient-to-br from-emerald-50/30 to-white";
    }
    if (score != null && score >= 60) {
        return "border-amber-100/80 bg-gradient-to-br from-amber-50/25 to-white";
    }
    return "border-slate-200/80 bg-white";
}

export function getOpportunityHighlights(opportunity) {
    const engagementAngles = opportunity?.engagementAngles ?? opportunity?.engagement_angles ?? [];
    const contentAngles = opportunity?.contentAngles ?? opportunity?.content_angles ?? [];
    if (engagementAngles.length > 0) return engagementAngles;
    return contentAngles;
}

export function getOpportunityBody(opportunity) {
    const description = String(opportunity?.description ?? "").trim();
    if (description) return description;
    return String(opportunity?.opportunity ?? "").trim();
}

export function hasExpandableOpportunityContent(opportunity) {
    const {
        engagementAngles = [],
        contentAngles = [],
        hashtags = [],
        eventName,
        event_name: eventNameSnake,
        opportunity: opportunityText,
    } = opportunity ?? {};
    const angles = engagementAngles.length > 0 ? engagementAngles : contentAngles;
    const event = String(eventName ?? eventNameSnake ?? "").trim();
    const opportunityBody = String(opportunityText ?? "").trim();
    const tagList = Array.isArray(hashtags) ? hashtags : [];

    return (
        angles.length > 0 ||
        tagList.length > 0 ||
        Boolean(event) ||
        Boolean(opportunityBody) ||
        (contentAngles.length > 0 && engagementAngles.length > 0)
    );
}
